<template>
  <div class="login">
    <el-form :model="editForm" :rules="rules" ref="editForm" label-position="left" label-width="0px" class="login__container">
      <h3 class="login__title">系统登录</h3>
      <el-form-item prop="username">
        <el-input type="text" v-model="editForm.username" auto-complete="off" placeholder="账号"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" v-model="editForm.password" auto-complete="off" placeholder="密码"></el-input>
      </el-form-item>
      <el-checkbox v-model="remember" checked class="login__remember">记住密码</el-checkbox>
      <el-form-item style="width:100%;">
        <el-button type="primary" style="width:100%;" @click="login" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<style scoped lang="scss">
  .login{
    &__container{
      -webkit-border-radius: 5px;
      border-radius: 5px;
      -moz-border-radius: 5px;
      background-clip: padding-box;
      margin: 180px auto;
      width: 350px;
      padding: 35px 35px 15px 35px;
      background: #fff;
      border: 1px solid #eaeaea;
      box-shadow: 0 0 25px #cac6c6;
      @media screen and (max-width: 768px){
        width: calc(100% - 48px - 70px);
      }
    }
    &__title{
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    &__remember{
      margin: 0px 0px 35px 0px;
    }
  }

</style>
<script>
import util from '../script/util'
import {login} from '../api/api'
export default {
  data () {
    return {
      logining: false,
      editForm: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      remember: true
    }
  },
  components: {
  },
  methods: {
    login () {
      let params = {
        username: this.editForm.username,
        password: this.editForm.password
      }
      login(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          localStorage.setItem('opid', data.d.opid)

          // 存角色数组 → 必须 JSON.stringify
          localStorage.setItem('roles', JSON.stringify(data.d.roles))

          if (this.remember) {
            localStorage.setItem('remember', true)
            localStorage.setItem('name', 'wxiao')
            localStorage.setItem('user', JSON.stringify(params))
          } else {
            localStorage.setItem('remember', false)
          }
          this.$router.push('/adList')
        } else {
          this.$notify({
            title: '提示',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      }).catch(() => {
        this.$notify({
          title: '提示',
          message: '服务器大脑短路啦',
          type: 'error'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/login.vue